import type { CartConfig } from '#types/config/pages/cart'
import type { RecursivePartial } from '#types/utils'

export default {
  coupon: {
    isAccordionOpen: true,
    isAutoPromoCodeEnabled: true,
  }
} satisfies RecursivePartial<CartConfig>
